import { CustomerProductLine } from '../../api'
import { getAllEnumOptions } from '../enum'

type ProductAliases = {
  [type: string]: string
}
const PRODUCT_ALIASES: ProductAliases = {
  Pro: 'Professional',
}

export const getAllCustomerProductLines = () => {
  const options = getAllEnumOptions(CustomerProductLine)
  return options.map(option => ({
    ...option,
    label: PRODUCT_ALIASES[option.label]
      ? PRODUCT_ALIASES[option.label]
      : option.label,
  }))
}

export const getCustomerProductLineLabel = (key?: CustomerProductLine) => {
  if (key === null || typeof key === 'undefined') return ''

  const label = CustomerProductLine[key]

  if (PRODUCT_ALIASES[label]) return PRODUCT_ALIASES[label]

  return label
}
